import {
  ModalLayout,
  Pagination,
  SearchFilters,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import { Table } from "../../Global/Table";
import OrderColumn from "../../Global/OrderColumn";
import useShopCertificate from "./useShopCertificate";
import BulkUpload from "./BulkUpload";

const ShopCertificateList = () => {
  const {
    shopCertificateState,
    shopCertificateList,
    isLoading,
    isFetching,
    tableFields,
    showEditModal,
    paginationOptions,
    refetch,
    updateShopCertificateFields,
    getRow,
    handleSearch,
    handleClearClick,
    handleEditColumnsClick,
    handlePagination,
    handlePageSize,
    handleSort,
    handleBulkUploadClick,
    handleBulkUploadClose,
    handleBulkDownload,
  } = useShopCertificate();

  return (
    <div className="col-auto pro-pt-3 pro-pb-6">
      <div className="pro-d-flex pro-items-start pro-gap-4 pro-mb-4">
        <div className="col-auto">
          <SearchFilters
            onSearchInput={handleSearch}
            showActions={true}
            handleActionClick={handleEditColumnsClick}
            loading={isLoading}
            SearchIcon={
              <span className="material-symbols-outlined"> search </span>
            }
            handleClear={handleClearClick}
            searchInputProps={{
              value: shopCertificateState?.search,
              placeholder: "Search folder / zip name",
            }}
          />
        </div>
        <div className="col-auto">
          <button
            className={`pro-btn pro-btn-primary pro-ms-3 items-center`}
            onClick={handleBulkUploadClick}
          >
            <span className="material-symbols-outlined x2">upload</span>
            <span>Bulk Upload</span>
          </button>
        </div>
      </div>
      <Table
        multiSelect={true}
        showCheckBox={true}
        data={shopCertificateList?.data?.data || []}
        uniqueID={"_id"}
        fields={tableFields}
        getRow={getRow}
        SortIcon={<FaSort />}
        handleSort={handleSort}
        clear={shopCertificateState?.clearSelection}
        loading={isFetching}
        perpage={shopCertificateState?.currentPageSize}
        assignable={true}
        editable={false}
        deletable={false}
        assignText={"Bulk Download"}
        assignIcon={<span className="material-symbols-outlined">download</span>}
        handleAssign={handleBulkDownload}
      />
      {shopCertificateList?.data?.data?.length > 0 && (
        <Pagination
          currentPage={shopCertificateState?.currentPage}
          defaultValue={paginationOptions?.find(
            (item) => item?.value === shopCertificateState?.currentPageSize,
          )}
          totalPageCount={Math.ceil(
            (shopCertificateList?.data?.total_count || 0) /
              shopCertificateState.currentPageSize,
          )}
          onPageChange={handlePagination}
          options={paginationOptions}
          onActionChange={handlePageSize}
          center
        />
      )}

      <ModalLayout show={showEditModal} handleClose={handleEditColumnsClick}>
        <div className="pro-m-5">
          <OrderColumn
            title={"Choose which columns you see"}
            refetchData={refetch}
            tableFields={shopCertificateList?.data?.fields}
            moduleId={shopCertificateList?.data?.module_id}
            updateData={updateShopCertificateFields}
          />
        </div>
      </ModalLayout>

      <ModalLayout
        show={shopCertificateState?.showBulkUpload}
        handleClose={handleBulkUploadClose}
        title={"Bulk Upload Shop Certificates"}
        closeIcon={<span className="material-symbols-outlined">close</span>}
      >
        <div className="pro-m-5">
          <BulkUpload refetch={refetch} handleClose={handleBulkUploadClose} />
        </div>
      </ModalLayout>
    </div>
  );
};

export default ShopCertificateList;
